var BaseViews = require('./base');
require('./entry-flow/entry-flow.scss');
var PickupDeliverySelect = require('./entry-flow/pickup-delivery-select');
var AgeGate = require('./entry-flow/age-gate');

var EntryFlow = BaseViews.LayoutView.extend({
    className: 'fmcy-plugin-bootstrap fmcy-entry-flow',
    template: require('./entry-flow/entry-flow.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null,
                skipAgeGate: false,
                referrer: 'entry',
                delivery_method: null // local_delivery || 'pickup'
            }
        );
    },
    regions : {
      currentStepRegion: '.fmcy-entry-flow-step-region',
    },
    _onWindowResize: function (event) {
      //this.$el.width($(window).width());
      this.$el.height($(window).height());
    },
    _renderPickupDeliverySelect: function () {
        var self = this;
        var pickUpDeliverySelectView = new PickupDeliverySelect({
            _appChannel: this.options._appChannel,
            _menuState: this.options._menuState,
            referrer: this.options.referrer,
            delivery_method: this.options.delivery_method
        });

        pickUpDeliverySelectView.on('location:selected', function (model) {
            self.trigger('close:clicked');
        });

        this.currentStepRegion.show(pickUpDeliverySelectView);
    },
    _renderAgeGate: function () {
        var self = this;
        var ageGate = new AgeGate({
            _appChannel: this.options._appChannel
        });

        ageGate.on('yes:clicked', function () {
            self._renderPickupDeliverySelect();
            self.options._appChannel.trigger('age:yes:clicked');
        });

        this.currentStepRegion.show(ageGate);
    },
    onRender: function() {
      var self = this;
      this._onWindowResize();
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));

      if (this.options.skipAgeGate) {
        this._renderPickupDeliverySelect();
      } else {
        this._renderAgeGate();
      }

      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = EntryFlow;



/** WEBPACK FOOTER **
 ** ./assets/js/common/entry-flow.js
 **/